"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ALIGNMENTS", {
  enumerable: true,
  get: function get() {
    return _constants.ALIGNMENTS;
  }
});
Object.defineProperty(exports, "COLLAPSED_HEIGHT_OPTIONS", {
  enumerable: true,
  get: function get() {
    return _constants.COLLAPSED_HEIGHT_OPTIONS;
  }
});
exports.default = void 0;

require("core-js/modules/es6.regexp.replace.js");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _values2 = _interopRequireDefault(require("lodash/values"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _debounce2 = _interopRequireDefault(require("lodash/debounce"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _AngleDown = _interopRequireDefault(require("@nerdwallet/react-icon/fontawesome/AngleDown"));

var _AngleUp = _interopRequireDefault(require("@nerdwallet/react-icon/fontawesome/AngleUp"));

var _currency = require("@nerdwallet/currency");

var _analytics = _interopRequireDefault(require("@nerdwallet/analytics"));

var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));

var _impression = require("@nerdwallet/analytics/react/impression");

var _deprecate = require("@nerdwallet/deprecate");

var _tracking = require("@nerdwallet/nw-client-lib/tracking");

var _constants = require("./constants");

var _utils = require("./utils");

var _expandableContentModule = _interopRequireDefault(require("./expandable-content.module.less"));

/**
 * Hook that consumes a ref and collapsed height option to determine whether content should
 * be collapsible.
 */
var useShouldContentExpand = function useShouldContentExpand(contentRef, collapsedHeightOption) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isToggleEnabled = _useState2[0],
      setIsToggleEnabled = _useState2[1]; // If the expanded content height exceeds the expected collapsed height, allow toggling.


  var handler = (0, _react.useCallback)(function () {
    var current = contentRef.current;
    var fullContentHeight = current.scrollHeight;
    var collapsedContentHeight = (0, _utils.retriveRemValueForHeightOption)(collapsedHeightOption);

    if (collapsedContentHeight) {
      var calculatedCollapsedHeight = (0, _utils.convertRemToPixels)(collapsedContentHeight.replace('rem', ''));
      setIsToggleEnabled(fullContentHeight >= calculatedCollapsedHeight);
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps -- directive added automatically by Shepherd migration
  [contentRef]); // Compute whether content is toggleable on mount

  (0, _react.useEffect)(function () {
    handler();
  }, // eslint-disable-next-line react-hooks/exhaustive-deps -- directive added automatically by Shepherd migration
  []); // Recompute whether content is toggleable on window resize

  (0, _react.useEffect)(function () {
    if (!window) return;
    var debouncedHandler = (0, _debounce2.default)(handler, _constants.RECOMPUTE_DELAY, {
      leading: true
    });
    window.addEventListener('resize', debouncedHandler); // eslint-disable-next-line consistent-return

    return function () {
      window.removeEventListener('resize', debouncedHandler);
    };
  }, [handler]);
  return isToggleEnabled;
};

var ExpandableContent = function ExpandableContent(_ref) {
  var analytics = _ref.analytics,
      buttonAlignment = _ref.buttonAlignment,
      children = _ref.children,
      className = _ref.className,
      collapsedHeight = _ref.collapsedHeight,
      enableAnalytics = _ref.enableAnalytics,
      id = _ref.id,
      isContentToggleable = _ref.isContentToggleable,
      isDefaultExpanded = _ref.isDefaultExpanded,
      shouldOmitExpandFunctionalityOnMobile = _ref.shouldOmitExpandFunctionalityOnMobile,
      shouldOmitShowMore = _ref.shouldOmitShowMore,
      showLessText = _ref.showLessText,
      showMoreText = _ref.showMoreText,
      trkSectionCategory = _ref.trkSectionCategory,
      trkSectionPosition = _ref.trkSectionPosition;
  var impressionContext = (0, _react.useContext)(_impression.ImpressionContext);
  var contentRef = (0, _react.useRef)(null);
  var isToggleEnabled = useShouldContentExpand(contentRef, collapsedHeight);

  var _useState3 = (0, _react.useState)(isDefaultExpanded),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isExpanded = _useState4[0],
      setIsExpanded = _useState4[1];

  var toggleBody = (0, _react.useCallback)(function () {
    // fire off legacy analytics
    (0, _tracking.elementInteraction)({
      interactionType: isExpanded ? 'COLLAPSE' : 'EXPAND',
      sectionCategory: trkSectionCategory,
      sectionPosition: trkSectionPosition,
      elementCategory: 'button',
      elementDomType: 'button',
      elementContent: isExpanded ? showLessText : showMoreText,
      elementName: "".concat(_constants.TRK_PRODUCT_LOCATION, "__expandable--").concat(id)
    }); // fire off bedrock analytics

    if (enableAnalytics || !(0, _isEmpty2.default)(analytics)) {
      var payload = {
        action: isExpanded ? 'collapse' : 'expand',
        entity_name: (0, _utils.buildAnalyticsEntityName)((analytics === null || analytics === void 0 ? void 0 : analytics.entityName) || _constants.MORE_DETAILS),
        interaction_type: 'press'
      };

      if (impressionContext !== null && impressionContext !== void 0 && impressionContext.impressionId) {
        payload.impression_id = impressionContext.impressionId;
      }

      _analytics.default.track('element_interacted', payload);
    }

    setIsExpanded(!isExpanded);
  }, [analytics, enableAnalytics, id, isExpanded, impressionContext, showLessText, showMoreText, trkSectionCategory, trkSectionPosition]);
  var handleButtonClick = (0, _react.useCallback)(function (event) {
    /**
     * If event is coming from clicking the Show More button,
     * set focus to the content body to force content to expand down and not up on Chrome,
     * and then remove the focus after toggle to avoid the "blue box" on Safari browsers.
     */
    var current = contentRef.current;
    event.preventDefault();
    current.focus();
    toggleBody();
    current.blur();
  }, [contentRef, toggleBody]);
  var handleBodyClick = (0, _react.useCallback)(function (event) {
    // Don't toggle if clicking on interactable inside of content
    if (!(0, _utils.isValidInteractable)(event) && !isExpanded) {
      toggleBody();
    }
  }, [isExpanded, toggleBody]);
  var handleBodyKeyDown = (0, _react.useCallback)(function (event) {
    if (event.keyCode === _constants.ENTER_KEY) {
      handleBodyClick(event);
    }
  }, [handleBodyClick]);
  (0, _deprecate.useDeprecatedPropsWarning)({
    component: 'ExpandableContent',
    deprecatedProps: [{
      version: '1.1.0',
      deprecated: 'enableAnalytics',
      migration: 'Use analytics instead.'
    }],
    props: {
      enableAnalytics: enableAnalytics
    }
  }); // Create classes for conditional mobile expand functionality.

  var expandableClasses = (0, _classes.default)({
    'display-none display-block--wide': shouldOmitExpandFunctionalityOnMobile
  });
  var nonExpandableClasses = (0, _classes.default)({
    'display-none': !shouldOmitExpandFunctionalityOnMobile,
    'display-block display-none--wide': shouldOmitExpandFunctionalityOnMobile
  });
  /**
   * Render the toggle button for the content.
   */

  var renderToggleButton = function renderToggleButton() {
    if (shouldOmitShowMore && !isExpanded || !isToggleEnabled) {
      return null;
    }

    var alignmentClass;

    switch (buttonAlignment) {
      case _constants.ALIGNMENTS.CENTER:
        alignmentClass = (0, _classes.default)('text-align-center');
        break;

      case _constants.ALIGNMENTS.LEFT:
      default:
        alignmentClass = (0, _classes.default)('text-align-left');
    }

    return /*#__PURE__*/_react.default.createElement("button", {
      className: (0, _classnames.default)(_expandableContentModule.default.toggleButton, expandableClasses, alignmentClass),
      "aria-controls": id,
      onClick: handleButtonClick,
      type: "button"
    }, /*#__PURE__*/_react.default.createElement(_currency.Type, {
      size: 1,
      bold: true,
      uppercase: true
    }, !isExpanded ? [showMoreText, " ", /*#__PURE__*/_react.default.createElement(_AngleDown.default, {
      textAligned: true,
      key: "2"
    })] : [showLessText, " ", /*#__PURE__*/_react.default.createElement(_AngleUp.default, {
      textAligned: true,
      key: "2"
    })]));
  };

  var renderContentComponent = function renderContentComponent() {
    var _ref2;

    var componentClasses = [expandableClasses, _expandableContentModule.default.contentContainer, (_ref2 = {}, (0, _defineProperty2.default)(_ref2, _expandableContentModule.default.isCollapsed, isToggleEnabled && !isExpanded), (0, _defineProperty2.default)(_ref2, _expandableContentModule.default[collapsedHeight], !isExpanded), (0, _defineProperty2.default)(_ref2, _expandableContentModule.default.nonFocusable, !isContentToggleable), (0, _defineProperty2.default)(_ref2, _expandableContentModule.default.toggleableContent, isToggleEnabled && isContentToggleable), _ref2)];
    var handleClick;
    var handleKeyDown;
    /**
     * We need the content body to have a tabIndex regardless of it being toggleable.
     * This is so that the Chrome browser can properly focus on it and lock it in place
     * when the "Show More" is clicked.
     */

    var tabIndex = -1;

    if (isToggleEnabled && isContentToggleable) {
      tabIndex = 0;
      handleClick = handleBodyClick;
      handleKeyDown = handleBodyKeyDown;
    }
    /* eslint-disable jsx-a11y/role-supports-aria-props, jsx-a11y/no-noninteractive-element-interactions */


    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      "aria-expanded": isExpanded ? 'true' : 'false',
      "aria-label": "content-pseudo-button",
      className: (0, _classnames.default)(componentClasses),
      id: id,
      onClick: handleClick,
      onKeyDown: handleKeyDown,
      ref: contentRef,
      role: "region",
      tabIndex: tabIndex
    }, children), /*#__PURE__*/_react.default.createElement("div", {
      className: nonExpandableClasses
    }, children));
    /* eslint-enable jsx-a11y/role-supports-aria-props, jsx-a11y/no-noninteractive-element-interactions */
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, renderContentComponent(), renderToggleButton());
};

ExpandableContent.propTypes = {
  /** The analytics props to pass to the components with analytics */
  analytics: _propTypes.default.shape({
    entityName: _propTypes.default.string
  }),

  /** Where the toggle button should appear underneath the content */
  buttonAlignment: _propTypes.default.oneOf((0, _values2.default)(_constants.ALIGNMENTS)),

  /** The body content that will expand (required) */
  children: _propTypes.default.node.isRequired,

  /** The id for the component to be used for accessibility purposes (required) */
  id: _propTypes.default.string.isRequired,

  /**
   * @deprecated
   * A flag to enable analytics
   */
  enableAnalytics: _propTypes.default.bool,

  /** The amount of content visible while content is collapsed */
  collapsedHeight: _propTypes.default.oneOf((0, _values2.default)(_constants.COLLAPSED_HEIGHT_OPTIONS)),

  /** The class name to apply to the component wrapper */
  className: _propTypes.default.string,

  /** The default expanded state */
  isDefaultExpanded: _propTypes.default.bool,

  /** When true, clicking on collapsed body content will expand itself */
  isContentToggleable: _propTypes.default.bool,

  /**
   * When true, the "Show More" button will be omitted
   * Must be disabled if `isContentToggleable` is false
   */
  // eslint-disable-next-line consistent-return
  shouldOmitShowMore: function shouldOmitShowMore(props, propName, componentName) {
    var shouldOmitShowMore = props[propName],
        isContentToggleable = props.isContentToggleable;

    if (!isContentToggleable && shouldOmitShowMore) {
      return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(componentName, "`. `").concat(shouldOmitShowMore, "` must be false, if isContentToggleable is also false."));
    }
  },

  /** When true, expansion behavior will not apply to mobile viewports. */
  shouldOmitExpandFunctionalityOnMobile: _propTypes.default.bool,

  /** The toggle open/closed text that shows when the accordion is open */
  showLessText: _propTypes.default.string,

  /** The toggle open/closed text that shows when the accordion is closed */
  showMoreText: _propTypes.default.string,

  /** The value to use for the tracking param `sectionCategory` */
  trkSectionCategory: _propTypes.default.string,

  /** The value to use for the tracking param `sectionPosition` */
  trkSectionPosition: _propTypes.default.number
};
ExpandableContent.defaultProps = {
  analytics: {},
  buttonAlignment: _constants.ALIGNMENTS.LEFT,
  className: '',
  collapsedHeight: _constants.COLLAPSED_HEIGHT_OPTIONS.FOUR_LINES_HEIGHT,
  enableAnalytics: false,
  isContentToggleable: false,
  isDefaultExpanded: false,
  shouldOmitExpandFunctionalityOnMobile: false,
  shouldOmitShowMore: false,
  showLessText: 'Show Less',
  showMoreText: 'Show More',
  trkSectionPosition: 0,
  trkSectionCategory: ''
};
var _default = ExpandableContent;
exports.default = _default;